import {MouseEvent, useEffect} from "react";

export const useModal = (
    isOpen: boolean,
    closeOnOverlayClick: boolean,
    backgroundScroll: boolean,
    close?: () => void
) => {
    const handleClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        closeOnOverlayClick && close && close();
    };

    const element =
        typeof window === "undefined"
            ? null
            : document.getElementById("modal_portal_container");

    useEffect(() => {
        const scrollBarWidth = window.innerWidth - document.body.clientWidth;
        if (!backgroundScroll && isOpen) {
            document.body.style.overflowY = "hidden";
            document.body.style.paddingRight = `${scrollBarWidth}px`; // to prevent layout shift when modal is open
        }
        if (!isOpen) {
            document.body.style.overflowY = "scroll";
            document.body.style.paddingRight = "0px";
        }
    }, [isOpen]);

    return {
        handleClick,
        element,
    };
};
